import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { InterfaceWidgetRegionWiseDetail } from "./models/widget-region-wise-detail";
import { WidgetRegionWiseDetailService } from "./services/widget-region-wise-detail.service";
import * as HSET from "./settings";
import { GenericUtils } from "../../../utilities/generic-utils";
import { CommonService } from "../../../services/common.service";
import { ActivatedRoute, Params } from "@angular/router";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: "widget-region-wise-detail",
  templateUrl: "./widget-region-wise-detail.component.html",
  styleUrls: ["./widget-region-wise-detail.component.scss"],
  providers: [WidgetRegionWiseDetailService]
})
export class WidgetRegionWiseDetailComponent implements OnInit, OnChanges, OnDestroy {
  @Input() TITLE: string;
  @Input() HEADINGS: string[] = [];
  @Input() FILTERS: object = {};
  @Input() OPTIONS: object;
  data = null;
  errorMessage = "";
  mockData = null;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private regionWiseDetailService: WidgetRegionWiseDetailService,
    private utils: GenericUtils,
    private commonservice: CommonService,
    private activateRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const intiFilter = JSON.parse(JSON.stringify(this.FILTERS));
    this.activateRoute.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe((params: Params) => {
      if (Object.keys(params).length) {
        this.FILTERS = this.commonservice.getFiltersParams(params, this.FILTERS);
        const fcCode = this.FILTERS['origin_fc_code'];
        if (fcCode) {
          this.FILTERS['origin_fc_code'] = fcCode.split(' / ')[1] ? fcCode.split(' / ')[1] : fcCode;

        } 
        this.FILTERS = this.utils.cleanNullKeys(this.FILTERS);
        this.getRegionWiseDetailService();
      } else {
        this.FILTERS = JSON.parse(JSON.stringify(intiFilter));
        this.getRegionWiseDetailService();
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    
  }

  getRegionWiseDetailService() {
    this.errorMessage = "";
    this.data = null;
    this.mockData = null;
    const query = JSON.parse(JSON.stringify(this.FILTERS));
    query.limit = "7";
    this.regionWiseDetailService
      .getRegionWiseDetail(this.OPTIONS, query).pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          if (response.data && response.data.length) {
            let total = 0;
            let delivered = 0;
            let invoiced = 0;
            let inTransit = 0;
            let toBeInvoiced = 0;

            response.data.map(data => {
              if (data['cancelled']) {
                data.total = data.total - data['cancelled']
              }
              total += isNaN(data.total) ? 0 : data.total;
              delivered += isNaN(data.delivered) ? 0 : data.delivered;
              invoiced += isNaN(data.invoiced) ? 0 : data.invoiced;
              inTransit += isNaN(data.in_transit) ? 0 : data.in_transit;
              toBeInvoiced += isNaN(data.to_be_invoiced) ? 0 : data.to_be_invoiced;
            });
            this.data = [
              ...response.data,
              ...[
                {
                  region: "Total",
                  total,
                  delivered,
                  invoiced,
                  in_transit: inTransit,
                  to_be_invoiced: toBeInvoiced
                }
              ]
            ];

          } else {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockData = HSET.data;
            this.HEADINGS = HSET.columns;
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockData = HSET.data;
          this.HEADINGS = HSET.columns;
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
